var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newClearValidationIssuesEvent(data) {
    var instance = {
        __type: "ClearValidationIssuesEvent:#DecisionsFramework.Design.Form",
        RuleID: null,
        ComponentID: null,
        ParentComponentId: null,
        SurfaceId: null
    };
    return __assign(__assign({}, instance), data);
}
export function isClearValidationIssuesEvent(object) {
    return object.__type === "ClearValidationIssuesEvent:#DecisionsFramework.Design.Form";
}
